import { render } from "./Chart2.vue?vue&type=template&id=137ab8ec&scoped=true"
import script from "./Chart2.vue?vue&type=script&lang=js"
export * from "./Chart2.vue?vue&type=script&lang=js"

import "./Chart2.vue?vue&type=style&index=0&id=137ab8ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-137ab8ec"]])

export default __exports__